import { useProviderLink } from "@app/projects/network-assessment/provider-hub/hooks/useProviderLink";
import { useContractEntityLink } from "@app/projects/network-assessment/provider-hub/hooks/useContractEntityLink";

export const useCellMarkdownWithCompleteProviderLinks = () => {
  const getProviderLink = useProviderLink();
  const getContractEntityLink = useContractEntityLink();

  // Contract entity ids have no distinguishing shape of their own (unlike provider keys, which are always
  // NPI:/PSV:PID:-prefixed), so the backend marks them with a CE: prefix (see
  // AiChatColumnFormatter.BuildLinkHref in Omnius.Custom.Services.AiChat) so they can be told apart here.
  return (cell: string): string => cell.replaceAll('](NPI:', `](${getProviderLink('')}npi:`)
    .replaceAll('](PSV:PID:', `](${getProviderLink('')}psv:pid:`)
    .replace(/\]\(CE:(\d+)\)/g, (_match, contractEntityId: string) => `](${getContractEntityLink(contractEntityId)})`);
}